var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 127,
    viewBox: "0 0 164 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_69)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_112_69",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 127
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H0V127H164V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_112_69)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.88 72.9312V118C122.88 122.57 119.14 126.32 114.56 126.32H8.32C3.74 126.31 0 122.57 0 118V36.32C0 31.74 3.74 28 8.32 28H80.2472C80.0838 29.4775 80 30.979 80 32.5C80 34.2417 80.1099 35.9577 80.3233 37.6415C79.8522 37.4534 79.3382 37.35 78.8 37.35C76.53 37.35 74.69 39.19 74.69 41.46C74.69 43.73 76.53 45.57 78.8 45.57C79.9584 45.57 81.0049 45.0908 81.752 44.3198C82.4917 46.7478 83.4533 49.0791 84.6133 51.29H5.29V118.8C5.29 119.44 5.54 120 5.96 120.43C6.38 120.86 6.95 121.1 7.59 121.1H115.63C116.27 121.1 116.83 120.85 117.26 120.43C117.69 120 117.93 119.44 117.93 118.8V72.9198C118.78 72.973 119.637 73 120.5 73C121.299 73 122.092 72.9769 122.88 72.9312ZM23.01 93.4H37.46V98.75H44.36V93.4H47.95V87.25H44.36V69.69H37.46L23.01 86.87V93.4ZM37.46 78.23V87.25H29.83L37.46 78.23ZM52.7 72.95C50.75 75.11 49.77 78.91 49.77 84.34C49.77 86.55 49.96 88.56 50.33 90.4C50.72 92.22 51.25 93.66 51.94 94.71C52.9 96.19 54.11 97.31 55.59 98.08C57.08 98.84 59.02 99.23 61.42 99.23C65.71 99.23 68.73 98.02 70.48 95.62C72.23 93.22 73.11 89.43 73.11 84.25C73.11 81.93 72.84 79.71 72.31 77.58C72.04 76.47 71.68 75.49 71.23 74.65C70.79 73.82 70.17 73.02 69.39 72.26C68.61 71.5 67.61 70.88 66.37 70.41C65.14 69.94 63.55 69.7 61.63 69.7C57.64 69.7 54.66 70.78 52.7 72.95ZM58.59 91.8C57.95 90.47 57.63 87.98 57.63 84.35C57.63 80.75 57.92 78.28 58.51 76.96C59.1 75.63 60.04 74.96 61.36 74.96C62.64 74.96 63.6 75.62 64.25 76.92C64.89 78.23 65.21 80.78 65.21 84.57C65.21 87.15 65.07 89.06 64.79 90.28C64.51 91.5 64.08 92.39 63.49 92.96C62.89 93.52 62.19 93.8 61.39 93.8C60.17 93.8 59.23 93.13 58.59 91.8ZM74.92 93.4H89.37V98.75H96.27V93.4H99.86V87.25H96.27V69.69H89.37L74.92 86.87V93.4ZM89.37 78.23V87.25H81.74L89.37 78.23Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_112_69",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 0,
    width: 76,
    height: 77
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H88V77H164V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_112_69)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.482 0C130.728 0 139.1 3.76035 145.159 9.8416C151.218 15.9213 154.965 24.3205 154.965 33.598C154.965 40.3847 152.958 46.7036 149.509 51.9861L164 67.8353L154.008 77L140.032 61.5705C134.723 65.1233 128.343 67.1945 121.482 67.1945C112.238 67.1945 103.866 63.4341 97.8065 57.3544C91.7475 51.2732 88 42.874 88 33.5965C88 24.3205 91.7475 15.9198 97.8065 9.84009C103.866 3.76035 112.238 0 121.482 0ZM130.409 20.5902L134.278 24.4995L125.316 33.5995L134.285 42.7086L130.403 46.5878L121.486 37.5343L112.557 46.6043L108.689 42.695L117.649 33.5935L108.68 24.4844L112.563 20.6052L121.479 29.6587L130.409 20.5902ZM142.518 12.4919C137.135 7.09052 129.697 3.74832 121.482 3.74832C113.267 3.74832 105.831 7.09052 100.448 12.4919C95.0649 17.8933 91.7355 25.3538 91.7355 33.5965C91.7355 41.8392 95.0649 49.3027 100.448 54.7026C105.831 60.1055 113.267 63.4447 121.482 63.4447C129.697 63.4447 137.135 60.1055 142.518 54.7026C147.901 49.3027 151.228 41.8407 151.228 33.5965C151.228 25.3538 147.901 17.8933 142.518 12.4919Z",
    fill: "#714BC6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 127,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/no-found.bec347f854c774734b9ffd5a0e7dd159.svg";
export { ForwardRef as ReactComponent };